import React from 'react';
import { Button } from 'is24-corecss';
import { IconS24Downsize24 } from '@is24/cosma-ui-icons';
import { css } from '@emotion/css';
import SchufaPreviewImage from '../images/new_solvency-doc-preview-3.png';
import { useIntl } from '@/i18n';

export interface SolvencyPreviewProps {
  onClose: () => void;
}

const styles = {
  stickyContent: css`
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  `,
  closePreviewButton: css`
    background-color: white !important;
    &:hover {
      background-color: #eaeaea !important;
    }
  `,
  scrollable: css`
    overflow-y: auto;
    overflow-x: hidden;
  `,
};

export const SchufaPreview: React.FC<SolvencyPreviewProps> = ({ onClose }) => {
  const { t } = useIntl();

  return (
    <div
      className={`padding-top palm-padding-top-l padding-horizontal ${styles.scrollable}`}
      data-testid='schufa-preview'
    >
      <div className={`${styles.stickyContent} grid grid-flex grid-justify-end`}>
        <Button
          appearance={'ghost'}
          size={'small'}
          className={`grid-item ${styles.closePreviewButton}`}
          onClick={onClose}
          data-testid='close-preview-button'
        >
          <IconS24Downsize24
            style={{ top: '0.17em' }}
            className='font-heading-xsmall-regular button-icon-margin-right'
            inline
          />
          {t({ id: 'benefits.schufaCheckMieterPlus.schufaModal.closePreview' })}
        </Button>
      </div>

      <div className='grid grid-flex one-whole grid-justify-center'>
        <img
          className='grid-item eleven-twelfth palm-one-whole margin-bottom-l margin-top-l'
          src={SchufaPreviewImage}
          alt='SCHUFA solvency check preview'
        />
      </div>
    </div>
  );
};
